import { actions } from './actions'

const initialState = {
  data: [],
}

export default function footerReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOAD_FOOTER_RESULT:
      return { ...state, data: action.payload.data }
    default:
      return state
  }
}
